import { render } from "./MarketplacePage.vue?vue&type=template&id=3e09c0b5&ts=true"
import script from "./MarketplacePage.vue?vue&type=script&lang=ts"
export * from "./MarketplacePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__